<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Policy Type Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :custom-filter="customSearch"
              :no-data-text="noDataText"
              item-key="key"
              show-select
              v-bind:search="search"
              v-model="selected"
              @input="enterSelect"
              @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected. </div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class="mb-2" @click="doSelect('All', 'polType')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class="mb-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn>
              <v-btn color="primary" dark class="mb-2" @click="doSelect('', 'polType')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import MessageMixin from '@/mixins/message'
export default {
  props: {
    'menu': Object
  },
  data() {
    return {
      headers: [
        { text: 'Policy Type', value: 'polType' },
        { text: 'Description', value: 'polTypeDesc' }
      ]
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit() {
      const apiURI = this.menu.getPolTypeList
      if (apiURI) {
        this.loading = true
        this.$http.get(apiURI).then(result => {
          this.items = []
          this.selectedItems = []
          const { data } = result.data
          if (data) {
            data.map(polTypeList => {
              const convertList = {
                key: polTypeList.polType,
                polType: polTypeList.polType,
                polTypeDesc: polTypeList.polTypeDesc
              }
              if (this.checkedItems.includes(polTypeList.branch)) {
                const policyTypeList = {
                  key: polTypeList.polType,
                  polType: polTypeList.polType,
                  polTypeDesc: polTypeList.polTypeDesc
                }
                this.selectedItems.push(policyTypeList)
              }
              this.items.push(convertList)
            })
          }
          if (this.checkedItems.toString() === 'All') {
            this.doReset()
            this.toggleAll()
          } else {
            this.toggleSelected()
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    helpListMixin
  ]
}
</script>
